module.exports = "/static/assets/3547fa1f2678a483a19f46852f36b426.svg";